import React, { useState, useEffect } from "react";
import { deleteOrder, getOrder, deleteItem } from "../../services/source";

import {
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Chip,
  Grid,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import colors from "../../config/colors";

const Compras = () => {
  const [compras, setCompras] = useState([]);

  const fetchCompras = async () => {
    const user = JSON.parse(localStorage.getItem("customer"));

    if (!user) return;

    try {
      const response = await getOrder({
        customer_id: user.id,
      });

      setCompras(response.data.orders);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCompras();
  }, []);

  const handleDeleteOrder = async (id) => {
    const confirmDelete = window.confirm("Delete this order?");

    if (!confirmDelete) return;

    try {
      await deleteOrder(id);

      setCompras(compras.filter((order) => order.id !== id));
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteItem = async (orderId, itemId) => {
    const confirmDelete = window.confirm("Remover este produto do pedido?");

    if (!confirmDelete) return;

    try {
      const response = await deleteItem({
        order_id: orderId,
        item_id: itemId,
      });

      console.log(response.data.message);

      setCompras((prev) =>
        prev.map((order) => {
          if (order.id === orderId) {
            return {
              ...order,
              items: order.items.filter((item) => item.id !== itemId),
            };
          }

          return order;
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        px: {
          xs: 1,
          sm: 2,
          md: 3,
        },
        pb: 10,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1000,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 3,
            fontWeight: "bold",
            fontSize: {
              xs: "1.5rem",
              sm: "2rem",
            },
          }}
        >
          Minhas Compras
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {compras.map((order) => (
            <Grid
              item
              xs={12}
              key={order.id}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 900,
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              >
                <CardContent>
                  {/* HEADER */}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: {
                        xs: "column",
                        sm: "row",
                      },
                      gap: 2,
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: colors.primary.secondary,
                          wordBreak: "break-word",
                        }}
                      >
                        {order.order_number}
                      </Typography>

                      <Typography variant="body2" color="text.secondary">
                        {new Date(order.created_at).toLocaleString()}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: {
                          xs: "flex-start",
                          sm: "flex-end",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <Chip
                          label={order.status}
                          color={
                            order.status === "Pending" ? "warning" : "success"
                          }
                        />

                        {order.status === "Pending" && (
                          <Chip
                            label="Apagar"
                            icon={<DeleteIcon />}
                            color="error"
                            onClick={() => handleDeleteOrder(order.id)}
                            sx={{
                              cursor: "pointer",
                            }}
                          />
                        )}
                      </Box>

                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        {Number(order.total).toLocaleString()}{" "}
                        {order.items?.[0]?.location
                          ?.toLowerCase()
                          .includes("lisboa")
                          ? "€"
                          : "Kz"}
                      </Typography>
                    </Box>
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  {/* PRODUCTS */}

                  {order.items.map((item, index) => (
                    <Box key={index}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: {
                            xs: "column",
                            sm: "row",
                          },
                          alignItems: {
                            xs: "center",
                            sm: "flex-start",
                          },
                          gap: 2,
                          p: 2,
                          borderRadius: 2,

                          backgroundColor:
                            order.status === "Pending" &&
                            item.stock < item.quantity
                              ? "#ffebee"
                              : "transparent",

                          border:
                            order.status === "Pending" &&
                            item.stock < item.quantity
                              ? "1px solid red"
                              : "none",
                        }}
                      >
                        <Box
                          component="img"
                          src={`${process.env.REACT_APP_API_URL}/${item.image}`}
                          alt={item.title}
                          sx={{
                            width: {
                              xs: 120,
                              sm: 90,
                            },
                            height: {
                              xs: 120,
                              sm: 90,
                            },
                            borderRadius: 2,
                            objectFit: "cover",
                          }}
                        />

                        <Box
                          sx={{
                            flex: 1,
                            width: "100%",
                            textAlign: {
                              xs: "center",
                              sm: "left",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                            }}
                          >
                            {item.title}
                          </Typography>

                          <Typography variant="body2" color="text.secondary">
                            {item.product_code}
                          </Typography>

                          <Typography variant="body2">
                            {item.location}
                          </Typography>
                          {order.status === "Pending" &&
                            item.stock < item.quantity && (
                              <Typography
                                color="error"
                                fontWeight="bold"
                                sx={{ mt: 1 }}
                              >
                                Sem Stock.
                              </Typography>
                            )}
                        </Box>

                        <Box
                          sx={{
                            width: {
                              xs: "100%",
                              sm: 130,
                            },
                            textAlign: {
                              xs: "center",
                              sm: "right",
                            },
                          }}
                        >
                          <Typography>Qty: {item.quantity}</Typography>
                          <Typography>
                            {Number(item.price).toLocaleString()}{" "}
                            {item.location?.toLowerCase().includes("lisboa")
                              ? "€"
                              : "Kz"}
                          </Typography>

                          <Typography fontWeight="bold">
                            {Number(item.subtotal).toLocaleString()}{" "}
                            {item.location?.toLowerCase().includes("lisboa")
                              ? "€"
                              : "Kz"}
                          </Typography>
                        </Box>

                        {order.status === "Pending" &&
                          item.stock < item.quantity && (
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: {
                                  xs: "center",
                                  sm: "flex-end",
                                },
                                width: {
                                  xs: "100%",
                                  sm: "auto",
                                },
                                mt: {
                                  xs: 1,
                                  sm: 0,
                                },
                              }}
                            >
                              <IconButton
                                color="error"
                                onClick={() =>
                                  handleDeleteItem(order.id, item.id)
                                }
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Box>
                          )}
                      </Box>

                      {index < order.items.length - 1 && (
                        <Divider sx={{ my: 2 }} />
                      )}
                    </Box>
                  ))}
                </CardContent>

                <Divider />

                {/* PAYMENT */}

                <Box
                  sx={{
                    p: 2,
                  }}
                >
                  <Typography fontWeight="bold">
                    Forma Pagamento:{" "}
                    {order.payment_method === "Cash"
                      ? "Dinheiro"
                      : order.payment_method === "Bank Transfer"
                        ? "Transferência Bancária"
                        : order.payment_method}
                  </Typography>

                  {order.payment_method === "Cash" && (
                    <Typography color="text.secondary" fontWeight="bold">
                      Contacto: "Phone:"
                    </Typography>
                  )}

                  {order.payment_method === "Bank Transfer" && (
                    <Typography color="text.secondary" fontWeight="bold">
                      Solicitar Coordenadas Bancárias para Transferência
                      <br />E enviar comprovativo de pagamento
                    </Typography>
                  )}
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Compras;
